var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconScience48Filled = function SvgIconScience48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.52 30.4-6.82-9.93V12.7H32V9.3H16v3.4h2.3v7.77L14.48 26l-3 4.36a5.27 5.27 0 0 0-.82 4.1 5.27 5.27 0 0 0 5.18 4.2h16.32a5.29 5.29 0 0 0 4.36-8.3v.04ZM26.3 12.7V21c-.012.357.094.708.3 1l2.29 3.34h-9.78L21.4 22a1.65 1.65 0 0 0 .3-1v-8.3h4.6Z",
    fill: "current"
  })));
};
export default SvgIconScience48Filled;